import {copyPlainText} from '../../../utils/copyPlainText';

function copyBySelection(text) {
    return new Promise((resolve, reject) => {
        try {
            const area = document.createElement('textarea');
            area.value = text;
            area.setAttribute('readonly', '');
            area.style.position = 'fixed';
            area.style.top = '-1000px';
            area.style.opacity = '0';
            document.body.appendChild(area);
            area.select();
            const copied = document.execCommand && document.execCommand('copy');
            document.body.removeChild(area);
            if (copied) resolve();
            else reject(new Error('COPY_UNSUPPORTED'));
        } catch (e) {
            reject(e);
        }
    });
}

/**
 * Copia al portapapeles. Va dentro del click (el navegador exige el gesto del usuario) y, si
 * `navigator.clipboard` RECHAZA —permiso denegado, documento sin foco—, prueba seleccionando el
 * texto en un campo oculto. `copyPlainText` sólo cae a ese camino cuando la API no existe.
 */
export function copyText(text) {
    return copyPlainText(text).catch(() => copyBySelection(text));
}
